<template>
  <div class="loading-content">
    <LoadingIcon color="primary" />
    <p v-if="text" class="loading-content__text">{{ text }}</p>
  </div>
</template>

<script setup lang="ts">
import LoadingIcon from '@/features/ui/components/icons/loading-icon.vue'

defineProps<{
  text?: string
}>()
</script>

<style lang="scss">
@import './loading-content.scss';
</style>
